import {MessarioAiBundleEnabled, MessarioAiGenerateTransport} from '@lib/messarioAi/types';

/**
 * Resolve Web K AI Generate transport.
 * Panel launch bundle wins; else Vite env; default server (Panel→NL OpenAI).
 */
export function resolveMessarioAiGenerateTransport(
  bundle?: Pick<MessarioAiBundleEnabled, 'generate_transport'> | null
): MessarioAiGenerateTransport {
  const fromBundle = bundle?.generate_transport;
  if(fromBundle === 'server' || fromBundle === 'local') {
    return fromBundle;
  }

  const fromVite = String(import.meta.env.VITE_MESSARIO_AI_GENERATE_TRANSPORT || '').trim().toLowerCase();
  if(fromVite === 'server' || fromVite === 'local') {
    return fromVite;
  }

  return 'server';
}
